import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateSchoolSubjects = () => {
  return (
    <Create
      title="Създаване на училищен предмет"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateSchoolSubjects;
